import { FrameName } from "../config";
import ShallowSeaFishingBoatBuildingTileEntity from "./ShallowSeaFishingBoatBuildingTileEntity";

class ShallowSeaBigFishingBoatBuildingTileEntity extends ShallowSeaFishingBoatBuildingTileEntity {
	public static readonly frameName = FrameName.SHALLOW_SEA_BIG_FISHING_BOAT;
}

export default ShallowSeaBigFishingBoatBuildingTileEntity;
